export default "__VITE_ASSET__CVXVn1uC__"